// extracted by mini-css-extract-plugin
module.exports = {"refresh-notice":"RefreshManager_refresh-notice__6rdt3","refresh-notice__title":"RefreshManager_refresh-notice__title__keLXZ"};